
export const appEnv          = process.env.REACT_APP_ENV ?? "";
export const appVersionLabel = process.env.REACT_APP_VersionLabel ?? "";
export const appBuildLabel   = process.env.REACT_APP_BuildLabel ?? "";

export const apimUrl    = process.env.REACT_APP_APIM_URL;
export const appRealm   = process.env.REACT_APP_REALM;
export const appAuthUrl = process.env.REACT_APP_AUTHSERVERURL;


export const dateFormat = "YYYY-MM-DD";
export const tz = "America/Edmonton";
export const appResourceId = 'wildfire-admin-api';

export const gracePeriod = appEnv === 'prod' ? 7 :1;
export const appStrings = {
    
    validate_dt_invalid:'Date is invalid.',
    validate_dt_past:" This date cannot be in the past. it can be today or in the future.",
    
    validate_access_sdt_empty : 'Start date cannot be empty. Enter a date.',
    validate_access_sdt_beforeOrSameEdt : 'Start date must be before or the same as access end date.',
    validate_access_edt_todayOrLaterSdt : 'End date must be today or later than access start date.',


    validate_role_grant_sdt_empty:" Granted start date cannot be empty. enter a date.",
    validate_role_grant_sdt_beforeOrSameEdt: " Granted start date must be before or the same as granted end.",

    validate_role_grant_edt_todayOrFuture:" Granted end date must be today or in the future.",
    validate_role_grant_edt_laterThanSdt:" Granted end date must be later than start date."
    
}    

    

